module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "login"
    }
  }, [_c('img', {
    staticClass: "center-block logo-login",
    attrs: {
      "src": "/static/img/logo_sima_100_full.png"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "text-center col-sm-12"
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.checkCreds($event)
      }
    }
  }, [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(0), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.username),
      expression: "username"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "username",
      "placeholder": "Usuario",
      "type": "text"
    },
    domProps: {
      "value": (_vm.username)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.username = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(1), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "password",
      "placeholder": "Password",
      "type": "password"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('button', {
    class: 'btn btn-danger btn-lg',
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Entrar "), (this.loading == '1') ? _c('div', {
    staticClass: "loading"
  }) : _vm._e()])]), _vm._v(" "), (_vm.response) ? _c('div', {
    staticClass: "text-red"
  }, [_c('p', {
    staticClass: "vertical-5p lead"
  }, [_vm._v(_vm._s(_vm.response))])]) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "fa fa-envelope"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "fa fa-lock"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6661d8d6"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Login.vue
// module id = 50
// module chunks = 1